import { render, staticRenderFns } from "./normal-card.vue?vue&type=template&id=27c0b56d"
import script from "./normal-card.vue?vue&type=script&lang=js"
export * from "./normal-card.vue?vue&type=script&lang=js"
import style0 from "./normal-card.vue?vue&type=style&index=0&id=27c0b56d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports